export default __webpack_public_path__ + "31d3ef121a5cf3631cee5670e231e10f.png";